<template>
<v-container fluid class="pa-1">
    <v-toolbar class="elevation-0" height="48px">
        <v-toolbar-title >Détail du temps</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="(event.eve_sta_id !== 'GEN03')"
            outlined rounded small :color="(true) ? 'grey' : 'green'" @click="openWorktime({ wti_id: 0 })">
            Ajouter<v-icon>mdi-playlist-edit</v-icon>
        </v-btn>
    </v-toolbar>
    <v-data-table v-bind:headers="headers" :items="itemList" item-key="sta_id"
        items-per-page-text="Lignes par page" :items-per-page-options="pagination.rowsPerItem" :loading="loading.getWorktime"> 
        <template v-slot:[`item.usr_firstName`]="{ item }">
            <v-chip v-if="item.wti_equ_id" class="ma-1 " small outlined color="secondary"><v-icon>mdi-tools</v-icon>&nbsp;{{ item.equ_name }}</v-chip>
            <v-chip v-else class="ma-1 " small outlined color="blue"><v-icon>mdi-account</v-icon>&nbsp;{{ item.usr_lastName.substring(0,1) + '. ' + item.usr_firstName }}</v-chip>
            <v-icon v-if="item.wti_equ_id" :color="(item.equ_hourly_cost) ? 'green' : 'red'">mdi-currency-eur</v-icon>
            <v-icon v-else :color="(item.usr_hourly_cost) ? 'green' : 'red'">mdi-currency-eur</v-icon>
        </template>
        <template v-slot:[`item.wti_date`]="{ item }" >
            <v-chip class="ma-1 " small outlined color="secondary"><v-icon>mdi-clipboard-text-clock-outline</v-icon>&nbsp;{{ $date(item.wti_date_start).format('DD/MM/YYYY') }}</v-chip><br />
        </template>
        <template v-slot:[`item.wti_duration`]="{ item }" >
            <v-text-field outlined hide-details dense class="rounded-lg" v-model="item.wti_duration_am" type="time"
                :disabled="(item.wti_id_am > 0)" label="Matin"
                @blur="storeWortime(item, 'AM')">
            </v-text-field>
            <v-text-field outlined hide-details dense class="rounded-lg mt-1" v-model="item.wti_duration_pm" type="time"
                :disabled="(item.wti_id_pm > 0)" label="Après-midi"
                @blur="storeWortime(item, 'PM')">
            </v-text-field>
        </template>
        <template v-slot:[`item.wti_id`]="{ item }" >
            <v-icon v-if="item.wti_id && (eventItem.eve_sta_id == 'GEN04' || eventItem.eve_sta_id == 'GEN03')" 
                left color='orange' title="Editer" @click="openWorktime(item)">
                mdi-pencil
            </v-icon>
            <v-icon v-else-if="item.wti_id" :color="typeListById[item.wti_typ_id].typ_color" title="Voir" @click="openWorktime(item)">
                mdi-eye
            </v-icon>
            <!--<v-icon v-if="(!item.wti_id)" 
                left color='green' title="Valider" @click="storeWortime(item)">
                mdi-content-save-plus-outline
            </v-icon>-->
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        De {{ pageStart }} à {{ pageStop }}
        </template>
        <template slot="no-data">
        <v-alert :value="( !loading.getWorktime )" color="error" icon="mdi-alert">
            Aucune saisie
        </v-alert>
        </template>
    </v-data-table>

    <!-- Totaux : temps matériel (lignes avec wti_equ_id) + coût agents (rôle WORK_SUPERVISOR et supérieur) -->
    <v-row v-if="(canSeeCost || hasEquipment)" align="center" no-gutters class="mt-1 pr-3">
        <v-spacer></v-spacer>
        <v-chip v-if="hasEquipment" small outlined color="secondary" class="ma-1">
            <v-icon small left>mdi-tools</v-icon>&nbsp;Temps matériel : {{ totalEquipmentHours }}
        </v-chip>
        <v-chip v-if="canSeeCost" small outlined color="primary" class="ma-1">
            <v-icon small left>mdi-clock-outline</v-icon>&nbsp;Total : {{ totalUserHours }}
        </v-chip>
        <v-chip small outlined color="success" class="ma-1">
            <v-icon small left>mdi-cash</v-icon>&nbsp;Coût total : {{ totalCost }} €
        </v-chip>
    </v-row>

    <v-dialog v-model="modalLayer" max-width="900" >
        <!-- <tab-layer v-if="modalLayer" :doc_id="doc_id" :switchModal="switchModal"></tab-layer> -->
    </v-dialog>
    <v-dialog v-model="modalWorktime" hide-overlay max-width="900" content-class="rounded-xxl micorise-v-card">
        <v-card color="grey lighten-4" min-width="350px" elevation="0" class="pa-0 elevation-0 rounded-xxl micorise-v-card" style="background-color: white">
        <v-toolbar color="secondary" dark class="elevation-1" height="50px">
            <v-btn icon><v-icon>mdi-chevron-down</v-icon></v-btn>
            <v-toolbar-title>Temps de travail</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon color="" @click.native="switchModal('modalWorktime', 0)"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="mt-2 pa-0">
            <WorktimeForm
                v-if="modalWorktime" :switchModal="switchModal"
                :groupItem="groupItem" :eve_id="event.eve_id">
            </WorktimeForm>
        </v-card-text>
        </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import WorktimeForm from './WorktimeForm.vue'

import { mapState, mapActions, mapWritableState } from 'pinia'
import { useUserStore } from '@/stores/user'
import { useEquipmentStore } from '@/stores/equipment'
import { useWorkTimeStore } from '@/stores/worktime'
import { useTypeStore } from '@/stores/type'
import { useEventStore } from '@/stores/event'

export default {
    name: 'worktime-list',
    props: ['event'],
    components: {
        WorktimeForm
    },
    computed: {
        ...mapWritableState(useWorkTimeStore, {workTimeitem: 'item' }),
        ...mapState(useWorkTimeStore,  {workTimeList: 'itemList' }),
        ...mapState(useUserStore,      {userList: 'itemList', me: 'me' }),
        ...mapState(useEquipmentStore, {equipmentList: 'itemList' }),
        ...mapState(useTypeStore,      {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapState(useEventStore,      {eventItem: 'item' }),
        // Coût total visible pour WORK_SUPERVISOR et rôles supérieurs (ADMIN/SUPER)
        canSeeCost(){
            return (this.me && ['ADMIN_USER', 'SUPER_USER', 'WORK_SUPERVISOR'].includes(this.me.role))
        },
        // Total des heures agents (hors temps matériel) au format HH:MM
        totalUserHours(){
            let totalMinutes = 0
            this.itemList.forEach(row => {
                if( row.wti_equ_id ){ return }
                totalMinutes += this.durationToMinutes(row.wti_duration_am) + this.durationToMinutes(row.wti_duration_pm)
            })
            let h = Math.floor(totalMinutes / 60)
            let m = totalMinutes % 60
            return String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0')
        },
        // Coût total = somme des (heures de chaque utilisateur × son coût horaire)
        totalCost(){
            let cost = 0
            this.itemList.forEach(row => {
                if( row.wti_equ_id ){ return }
                let usr = this.userList.find(obj => { return obj.id === row.usr_id })
                let hourlyCost = (usr && usr.hourlyCost) ? parseFloat(usr.hourlyCost) : 0
                if( hourlyCost > 0 ){
                    let minutes = this.durationToMinutes(row.wti_duration_am) + this.durationToMinutes(row.wti_duration_pm)
                    cost += (minutes / 60) * hourlyCost
                }
            })
            return cost.toFixed(2)
        },
        // Le tableau contient des lignes de temps matériel
        hasEquipment(){
            return this.itemList.some(row => !!row.wti_equ_id)
        },
        // Total des heures matériel au format HH:MM
        totalEquipmentHours(){
            let totalMinutes = 0
            this.itemList.forEach(row => {
                if( !row.wti_equ_id ){ return }
                totalMinutes += this.durationToMinutes(row.wti_duration_am) + this.durationToMinutes(row.wti_duration_pm)
            })
            let h = Math.floor(totalMinutes / 60)
            let m = totalMinutes % 60
            return String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0')
        },
    },
    watch: {
        'event._pivot.users': {
            handler () {
                this.computeWorktime()
                this.distributeDuration()
            },
            deep: true
        },
        // Ajout/retrait de matériel affecté : (re)génère les lignes de temps matériel
        'event._pivot.equipments': {
            handler () {
                this.computeWorktime()
            },
            deep: true
        }
    },
    data: function () {
      return {
            loading: { uploadBtn: false, getWorktime: false },         // Enregistrement en cours...
            pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
            headers: [
            { text: 'Date',         align: 'left', value: 'wti_date'},
            { text: 'Utilisateur',  align: 'left', value: 'usr_firstName'},
            { text: 'Matin / Après-midi', value: 'wti_duration' },
            { text: 'Action',       align: 'right', value: 'wti_id' }
            ],
            enableAdd: true,
            modalLayer : false,
            modalWorktime: false,
            itemList : [],
            groupItem: null
      }
    },
    async mounted (){
        await this.fetchItems('?wti_eve_id=' + this.event.eve_id)
        this.computeWorktime()
        if( this.event.eve_duration ){
            await this.distributeDuration()
        }
    },
    methods: {
        ...mapActions(useWorkTimeStore, { fetchItems: 'fetchItems', updateItem: 'updateItem', storeItem: 'storeItem' }),
        async storeWortime(item, period){
            let duration = (period === 'PM') ? item.wti_duration_pm : item.wti_duration_am
            if( !duration || duration === '00:00' ){
                return
            }
            this.workTimeitem.wti_eve_id     = this.event.eve_id
            this.workTimeitem.wti_usr_id     = item.usr_id
            this.workTimeitem.wti_equ_id     = item.wti_equ_id
            this.workTimeitem.wti_typ_id     = 'WTI01'
            this.workTimeitem.wti_date_start = new Date().toJSON().slice(0, 10)
            this.workTimeitem.wti_duration   = duration
            this.workTimeitem.wti_period     = period
            await this.storeItem()
            await this.fetchItems('?wti_eve_id=' + this.event.eve_id)
            this.computeWorktime()
            await this.updateEventDuration()
            this.$root.$toast({ color: 'success', text: 'Temps enregistré !' })
        },
        // Recalcule la durée de l'événement depuis les temps saisis (f_worktime)
        // et notifie le parent (EventForm) pour mettre à jour le champ "Durée"
        async updateEventDuration(){
            if( !this.event.eve_id || this.event.eve_id <= 0 ){
                return
            }
            try {
                const response = await this.$http.put('/events/' + this.event.eve_id + '/computeduration/?eve_id=' + this.event.eve_id)
                const raw      = (response.data && response.data.data) ? response.data.data.eve_duration : null
                if( raw ){
                    // 'HH:MM:SS' -> 'HH:MM'
                    this.$emit('computeduration', raw.substring(0, raw.length - 3))
                }
            } catch(e) {
                console.log('updateEventDuration error:', e)
            }
        },
        computeWorktime(){
            this.itemList = []
            let users = []
            let equipments = []
            // Regroupe les lignes f_worktime (une par période AM/PM) en une seule
            // ligne d'affichage par utilisateur / matériel.
            let groups = {}
            this.workTimeList.forEach(element => {
                let key = element.wti_usr_id + '-' + (element.wti_equ_id || 0)
                if( !groups[key] ){
                    let equ = this.equipmentList.find(obj => { return obj.equ_id === element.wti_equ_id })
                    groups[key] = {
                        usr_firstName  : element.usr_firstName,
                        usr_lastName   : element.usr_lastName,
                        usr_id         : element.wti_usr_id,
                        usr_hourly_cost: parseInt(element.usr_hourly_cost),
                        equ_hourly_cost: parseInt(element.equ_hourly_cost),
                        wti_usr_id     : element.wti_usr_id,
                        wti_equ_id     : element.wti_equ_id,
                        equ_name       : (element.wti_equ_id && equ) ? equ.equ_name : '',
                        wti_typ_id     : element.wti_typ_id,
                        wti_date_start : element.wti_date_start,
                        wti_date       : element.wti_date_start,
                        wti_id         : 0,
                        wti_id_am      : 0,
                        wti_id_pm      : 0,
                        wti_duration_am: '00:00',
                        wti_duration_pm: '00:00'
                    }
                    this.itemList.push(groups[key])
                }
                let group = groups[key]
                if( element.wti_period === 'PM' ){
                    group.wti_id_pm       = element.wti_id
                    group.wti_duration_pm = (element.wti_duration || '00:00').substring(0, 5)
                } else {
                    group.wti_id_am       = element.wti_id
                    group.wti_duration_am = (element.wti_duration || '00:00').substring(0, 5)
                }
                group.wti_id = group.wti_id_am || group.wti_id_pm
                users.push(element.wti_usr_id)
                if( element.wti_equ_id ){
                    equipments.push(element.wti_equ_id)
                }
            })
            let pivotUsers = (this.event._pivot && this.event._pivot.users) ? this.event._pivot.users : []
            let defaultDuration = (this.event.eve_duration && this.event.eve_duration !== '00:00:00' && this.event.eve_duration !== '00:00')
                ? this.event.eve_duration : '00:00'
            let defaultDurationAm = (this.event.eve_duration_am && this.event.eve_duration_am !== '00:00') ? this.event.eve_duration_am : '00:00'
            let defaultDurationPm = (this.event.eve_duration_pm && this.event.eve_duration_pm !== '00:00') ? this.event.eve_duration_pm : '00:00'
            if( defaultDurationAm === '00:00' && defaultDurationPm === '00:00' ){
                defaultDurationAm = defaultDuration
                defaultDurationPm = defaultDuration
            }
            pivotUsers.forEach(element => {
                if( !users.includes(element) ){
                    let usr = this.userList.find(obj => { return obj.id === element })
                    this.itemList.push({
                        usr_firstName: (usr) ? usr.firstName : '!ERROR!',
                        usr_lastName : (usr) ? usr.lastName :  '!ERROR!',
                        usr_id       : element,
                        wti_equ_id   : null,
                        equ_name     : '',
                        wti_id       : 0,
                        wti_usr_id   : element,
                        wti_typ_id   : 'WTI01',
                        wti_duration : defaultDuration,
                        wti_duration_am: defaultDurationAm,
                        wti_duration_pm: defaultDurationPm,
                        wti_date     : '2024/01/01'
                    })
                }
            })
            let pivotEquipments = (this.event._pivot && this.event._pivot.equipments) ? this.event._pivot.equipments : []
            pivotEquipments.forEach(element => {
                if( !equipments.includes(element) ){
                    let equ = this.equipmentList.find(obj => { return obj.equ_id === element })
                    let usr = this.userList.find(obj => { return obj.id === this.event.eve_usr_id_created })
                    this.itemList.push({
                        usr_firstName: (usr) ? usr.firstName : '!ERROR!',
                        usr_lastName : (usr) ? usr.lastName :  '!ERROR!',
                        usr_id       : this.event.eve_usr_id_created,
                        wti_equ_id   : element,
                        equ_name     : (equ) ? equ.equ_name : '!ERROR!',
                        wti_id       : 0,
                        wti_typ_id   : 'WTI01',
                        wti_duration : '00:00',
                        wti_duration_am: '00:00',
                        wti_duration_pm: '00:00',
                        wti_date     : '2024/01/01'
                    })
                }
            })
        },
        async distributeDuration(){
            if( !this.event.eve_id || this.event.eve_id <= 0 ){
                return
            }
            let durationAm = (this.event.eve_duration_am && this.event.eve_duration_am !== '00:00') ? this.event.eve_duration_am : null
            let durationPm = (this.event.eve_duration_pm && this.event.eve_duration_pm !== '00:00') ? this.event.eve_duration_pm : null
            let duration   = this.event.eve_duration
            if( !durationAm && !durationPm ){
                if( !duration || duration === '00:00:00' || duration === '00:00' ){
                    return
                }
                // Total seul : division par 2 pour matin / après-midi
                durationAm = this.halfDuration(duration)
                durationPm = durationAm
            }
            let existingUsers = this.workTimeList.map(w => w.wti_usr_id)
            let pivotUsers = (this.event._pivot && this.event._pivot.users) ? this.event._pivot.users : []
            let hasNew = false
            for( const usrId of pivotUsers ){
                if( !existingUsers.includes(usrId) ){
                    if( durationAm && durationAm !== '00:00' ){
                        this.workTimeitem.wti_eve_id     = this.event.eve_id
                        this.workTimeitem.wti_usr_id     = usrId
                        this.workTimeitem.wti_equ_id     = null
                        this.workTimeitem.wti_typ_id     = 'WTI01'
                        this.workTimeitem.wti_date_start = new Date().toJSON().slice(0, 10)
                        this.workTimeitem.wti_duration   = durationAm
                        this.workTimeitem.wti_period     = 'AM'
                        await this.storeItem()
                        hasNew = true
                    }
                    if( durationPm && durationPm !== '00:00' ){
                        this.workTimeitem.wti_eve_id     = this.event.eve_id
                        this.workTimeitem.wti_usr_id     = usrId
                        this.workTimeitem.wti_equ_id     = null
                        this.workTimeitem.wti_typ_id     = 'WTI01'
                        this.workTimeitem.wti_date_start = new Date().toJSON().slice(0, 10)
                        this.workTimeitem.wti_duration   = durationPm
                        this.workTimeitem.wti_period     = 'PM'
                        await this.storeItem()
                        hasNew = true
                    }
                }
            }
            if( hasNew ){
                await this.fetchItems('?wti_eve_id=' + this.event.eve_id)
                this.computeWorktime()
            }
        },
        halfDuration(duration){
            let parts = (duration || '00:00').split(':')
            let totalMinutes = parseInt(parts[0], 10) * 60 + parseInt(parts[1] || 0, 10)
            let half = Math.round(totalMinutes / 2)
            let h = Math.floor(half / 60)
            let m = half % 60
            return String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0')
        },
        // Convertit une durée "HH:MM" (ou "HH:MM:SS") en minutes
        durationToMinutes(duration){
            if( !duration || duration === '00:00' ){
                return 0
            }
            let parts = duration.split(':')
            return parseInt(parts[0], 10) * 60 + parseInt(parts[1] || 0, 10)
        },
        openWorktime(item){
            // item = ligne groupée (1 ligne affichée = jusqu'à 2 lignes f_worktime AM/PM)
            this.groupItem = item
            this.switchModal('modalWorktime', 1)
        },
        async switchModal(name, mode, refresh){
            name    = name || 'modalWorktime'
            mode    = mode || 0
            refresh = refresh || false
            this[name] = mode
            if( refresh ){
                await this.fetchItems('?wti_eve_id=' + this.event.eve_id)
                this.computeWorktime()
                await this.updateEventDuration()
            }
        }
    }
}
</script>